export default function submitForm(section, form, values, nopersist, callback) {
	const formValues = {};

	Object.keys(values).forEach((field) => {
		formValues[field.replace(`${section}_${form}_`, '')] = values[field];
	});

	Object.keys(nopersist).forEach((field) => {
		formValues[field.replace(`${section}_${form}_`, '')] = nopersist[field];
	});

	callback(formValues);
}
